(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-first-12"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqbutton"] && !Shopify.designMode) return;
  try {
    
function initFaqButtons() {
  document.querySelectorAll('.faq-button').forEach(button => {

    if (button.dataset.initialized) return;
    button.dataset.initialized = 'true';

    button.addEventListener('click', function() {
      let targetId = this.dataset.scrollTarget;

      if (!targetId) {
        console.warn('No target specified');
        return;
      }

      // Be forgiving if the merchant forgot the leading "#"
      if (!targetId.startsWith('#')) {
        targetId = '#' + targetId;
      }

      let targetElement;
      try {
        targetElement = document.querySelector(targetId);
      } catch (err) {
        console.warn('Invalid target selector:', targetId, err);
        return;
      }

      if (!targetElement) {
        console.warn('Target element not found:', targetId, '— make sure this matches the "Anchor ID" setting on the FAQ section exactly.');
        return;
      }

      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initFaqButtons);
document.addEventListener('shopify:section:load', initFaqButtons);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
